export const PROSE = `prose sm:prose-lg xl:prose-xl prose-indigo dark:prose-invert max-w-none prose-blockquote:not-italic`;
